import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Mail, AlertTriangle, Clock } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EmailStatsWidget = () => {
  const [s, setS] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => axios.get(`${API}/email/stats`).then(r => alive && setS(r.data)).catch(() => {});
    load();
    const iv = setInterval(load, 60000);
    return () => { alive = false; clearInterval(iv); };
  }, []);
  if (!s) return null;

  const pct = Math.min(100, s.quota_percent || 0);
  const warn = s.quota_warning;

  return (
    <div className="border border-slate-200 rounded-lg bg-white p-4 flex flex-wrap items-center gap-6" data-testid="email-stats-widget">
      <div className="flex items-center gap-3">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${warn ? 'bg-amber-100' : 'bg-[#1e1b4b]/10'}`}>
          {warn ? <AlertTriangle className="w-5 h-5 text-amber-600" /> : <Mail className="w-5 h-5 text-[#1e1b4b]" />}
        </div>
        <div>
          <div className="text-xs text-slate-500 uppercase tracking-wider">E-mails deze maand</div>
          <div className="font-bold text-[#1e1b4b] text-lg">{s.sent_this_month} <span className="text-slate-400 font-normal text-sm">/ {s.quota_month}</span></div>
        </div>
      </div>
      <div className="flex-1 min-w-[160px]">
        <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
          <div className={`h-full ${warn ? 'bg-amber-500' : 'bg-emerald-500'}`} style={{ width: `${pct}%` }} />
        </div>
        <div className="text-xs text-slate-500 mt-1">{pct}% van je maandquota gebruikt {warn && <span className="text-amber-600 font-medium">— waarschuwing: 80%+ bereikt</span>}</div>
      </div>
      <div className="flex items-center gap-4 text-xs">
        <div><span className="text-slate-500">Vandaag:</span> <span className="font-semibold text-[#1e1b4b]">{s.sent_today}</span></div>
        <div><span className="text-slate-500">In wachtrij:</span> <span className="font-semibold flex items-center gap-1 inline-flex"><Clock className="w-3 h-3" />{s.queued}</span></div>
        <div><span className="text-slate-500">Mislukt:</span> <span className="font-semibold text-rose-600">{s.failed_this_month}</span></div>
      </div>
    </div>
  );
};

export default EmailStatsWidget;
